// Module
var code = "<span id=\"V-A33A19C1-08C1-4321-A846-76A11720D53F\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"> {Binding Text} </span> ";
// Exports
export default code;